import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "srOnly"
}
const _hoisted_2 = {
  key: 0,
  class: "statusText"
}
const _hoisted_3 = {
  key: 0,
  class: "upcomingText"
}
const _hoisted_4 = {
  key: 1,
  class: "arrowIcon"
}

import { Skeletor } from 'vue-skeletor';
import { Port } from '@/types';
import { IconPositionType, ServiceStatusType } from '../../types';
import { GetServiceStatus } from '../ServiceStatus/index';
import { RouteDetail } from '..';
import { Icon } from '../../Atoms';
import { IconText } from '../../Molecules';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteItem',
  props: {
    index: {},
    status: {},
    ports: {},
    destinationName: {},
    clickHandler: { type: Function },
    isArrowHidden: { type: Boolean },
    isLoading: { type: Boolean },
    isStatusChangeUpcoming: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "routeItem",
    role: "link",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
  }, [
    (_ctx.index !== undefined)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Route " + _toDisplayString(_ctx.index + 1) + ": ", 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(RouteDetail), {
      status: _ctx.status,
      ports: _ctx.ports,
      "destination-name": _ctx.destinationName,
      "is-loading": _ctx.isLoading
    }, {
      infoCard: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["infoCard", _ctx.status])
        }, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_unref(GetServiceStatus)(_ctx.status).text), 1),
                (_ctx.isStatusChangeUpcoming)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(IconText), {
                        "icon-name": "exclamation",
                        text: _ctx.$t('View future updates'),
                        "icon-pos": _unref(IconPositionType).PosLeft
                      }, null, 8, ["text", "icon-pos"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
              : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["status", "ports", "destination-name", "is-loading"]),
    (!_ctx.isArrowHidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(Icon), { "icon-name": "redLink" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})